import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const HomeSelect = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page padding">
			<h3>내 부동산 분류를 선택해주세요.</h3>

			<div className={`${styles["choose-group"]} mt_40`}>
				<div>
					<div>아파트</div>
				</div>
				<div>
					<div>연립/다세대</div>
				</div>
				<div>
					<div>오피스텔</div>
				</div>
			</div>
		</div>
	)
}

export default HomeSelect